"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var GAMES_BY_PAGE = 10;
var SELECTED_CATEGORY = 'selected_category';
var SELECTED_PROVIDER = 'selected_provider';
var SELECTED_SEARCH_BY_TITLE = 'selected_search_by_title';
var useGamesMore = function (_a) {
    var _b;
    var defaultSearchCategory = _a.defaultSearchCategory;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var config = (0, swr_hooks_1.useConfig)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var _c = (0, swr_hooks_1.useCache)(), getDataFromCache = _c.getDataFromCache, setDataToCache = _c.setDataToCache;
    var initialSearch = (0, react_1.useMemo)(function () { return getDataFromCache(SELECTED_SEARCH_BY_TITLE); }, [getDataFromCache]);
    var initialCategory = (0, react_1.useMemo)(function () { return getDataFromCache(SELECTED_CATEGORY) || defaultSearchCategory; }, [getDataFromCache, defaultSearchCategory]);
    var initialProvider = (0, react_1.useMemo)(function () { return getDataFromCache(SELECTED_PROVIDER) || null; }, [getDataFromCache]);
    var _d = (0, react_1.useState)(initialSearch ? null : initialProvider ? null : initialCategory), category = _d[0], setCategory = _d[1];
    var _e = (0, react_1.useState)(initialProvider), provider = _e[0], setProvider = _e[1];
    var setCategoryHandler = (0, react_1.useCallback)(function (category) {
        setCategory(category);
        setDataToCache(SELECTED_CATEGORY, category);
    }, [setCategory, setDataToCache]);
    var setProviderHandler = (0, react_1.useCallback)(function (provider) {
        setProvider(provider);
        setDataToCache(SELECTED_PROVIDER, provider);
    }, [setProvider, setDataToCache]);
    var showGamesCountFromConfig = (0, react_1.useMemo)(function () {
        var _a, _b;
        if (!((_a = config === null || config === void 0 ? void 0 : config.showGamesByPage) === null || _a === void 0 ? void 0 : _a.home))
            return null;
        var settings = (_b = config === null || config === void 0 ? void 0 : config.showGamesByPage) === null || _b === void 0 ? void 0 : _b.home;
        if (((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile384) || (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile460)) && (settings === null || settings === void 0 ? void 0 : settings['xs']))
            return settings === null || settings === void 0 ? void 0 : settings['xs'];
        if (((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile550) ||
            (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile660) ||
            breakpoints.mobile767) &&
            (settings === null || settings === void 0 ? void 0 : settings['mobile']))
            return settings === null || settings === void 0 ? void 0 : settings['mobile'];
        if (breakpoints.tablet && (settings === null || settings === void 0 ? void 0 : settings['tablet']))
            return settings === null || settings === void 0 ? void 0 : settings['tablet'];
        return settings === null || settings === void 0 ? void 0 : settings['default'];
    }, [breakpoints, (_b = config === null || config === void 0 ? void 0 : config.showGamesByPage) === null || _b === void 0 ? void 0 : _b.home]);
    var _f = (0, swr_hooks_1.useSearchGamesByFilters)({
        showCount: showGamesCountFromConfig
            ? showGamesCountFromConfig
            : breakpoints.tablet || breakpoints.mobile
                ? 9
                : GAMES_BY_PAGE,
        category: category,
        providerId: provider,
    }), data = _f.data, searchGamesToShow = _f.gamesToShow, searchValue = _f.searchValue, currentPage = _f.currentPage, onLoadBtnClick = _f.onLoadBtnClick, onPageBtnClick = _f.onPageBtnClick, onSearchClear = _f.onSearchClear, onFiltersClear = _f.onFiltersClear, onSearchChange = _f.onSearchChange, categories = _f.categories, providers = _f.providers, isSubmitting = _f.isSubmitting;
    var handleOnFiltersClear = (0, react_1.useCallback)(function () {
        setCategoryHandler(null);
        setProviderHandler(null);
        onFiltersClear();
    }, [setCategoryHandler, setProviderHandler, onFiltersClear]);
    return (0, react_1.useMemo)(function () { return ({
        t: t,
        breakpoints: breakpoints,
        gamesToShow: searchGamesToShow || [],
        gamesCount: (data === null || data === void 0 ? void 0 : data.data.totalCount) || 0,
        categories: categories,
        providers: providers,
        category: category,
        provider: provider,
        setProvider: setProviderHandler,
        setCategory: setCategoryHandler,
        onLoadBtnClick: onLoadBtnClick,
        onPageBtnClick: onPageBtnClick,
        onSearchClear: onSearchClear,
        onFiltersClear: handleOnFiltersClear,
        onSearchChange: onSearchChange,
        searchValue: searchValue,
        currentPage: currentPage,
        isSubmitting: isSubmitting,
    }); }, [
        t,
        breakpoints,
        searchGamesToShow,
        data === null || data === void 0 ? void 0 : data.data.totalCount,
        categories,
        providers,
        category,
        provider,
        setProviderHandler,
        setCategoryHandler,
        onLoadBtnClick,
        onPageBtnClick,
        onSearchClear,
        handleOnFiltersClear,
        onSearchChange,
        searchValue,
        currentPage,
        isSubmitting,
    ]);
};
exports.default = useGamesMore;
